import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                control: 'control'
            }
        }

        this.lastIndex = 0
        this.currentIndex = 0
    }

    init() {
        this.slides          = this.$('slide')
        this.slideTitles     = this.$('slideTitle')
        this.controls        = this.$('control')
        this.$inview         = this.$('inview')

        this.carousel = new Swiper(this.$('carousel'), {
            slidesPerView: 1,
            spaceBetween: 25,
            autoHeight: true,
            simulateTouch: false,
            allowTouchMove: false
        })

        this.setActive(0)
    }

    control(e) {
        let el = e.curTarget
        let index = Array.from(this.controls).indexOf(el)

        this.carousel.slideTo(index)
        this.setActive(index)
    }

    setActive(index) {
        this.currentIndex = index
        
        // Prev slide
        this.controls[this.lastIndex].classList.remove('is-active')
        const lastSplitModuleId = this.slideTitles[this.lastIndex].dataset.moduleSplitText
        this.call('resetStyles', null, 'SplitText', lastSplitModuleId)

        requestAnimationFrame(() => {
            const $inview = this.$inview[0]

            if ($inview && $inview.classList.contains('is-inview')) {
                // Current slide
                this.showTitle()
            }
    
            // Set for next slide
            this.lastIndex = index
        })

    }

    showTitle() {

        requestAnimationFrame(() => {
            // Current slide
            this.controls[this.currentIndex].classList.add('is-active')
            const splitModuleId = this.slideTitles[this.currentIndex].dataset.moduleSplitText
            this.call('playAnime', null, 'SplitText', splitModuleId)
        })
    }

    destroy() {
        super.destroy()
        this.carousel.destroy(true,true)
    }
}
